import React, { JSX } from 'react';

import TypographyLink, { type TypographyLinkProps } from '@fmbt/ui/TypographyLink';

type Props = Pick<TypographyLinkProps, 'customColor'> & {
  email: string;
  id?: string;
  label?: string;
};

/**
 * Creates a mailto link based on an email address.
 */
function AnchorMailto({
  email,
  label,
  ...rest
}: Props): JSX.Element {
  return (
    <TypographyLink
      {...rest}
      href={`mailto:${email}`}
      underline
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      {label || email}
    </TypographyLink>
  );
}

export default AnchorMailto;
